export default __webpack_public_path__ + "static/construction-b9020741b1bc9e81a924541e3e2ff6fd.jpg";